(function () {
  var cards = document.querySelectorAll('.appointment-card');
  var submitButton = document.querySelector('.appointment-booking__submit');
  var dateInput = document.querySelector('.appointment-booking__date');
  var timeSelect = document.querySelector('.appointment-booking__time');
  if (!cards.length || !submitButton || !dateInput || !timeSelect) return;

  var originalLabel = submitButton.textContent;
  var selectedVariantId = null;

  function updateSubmitState() {
    submitButton.disabled = !(selectedVariantId && dateInput.value && timeSelect.value);
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      var variantId = card.dataset.variantId;
      if (!variantId) return;

      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });

      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      selectedVariantId = variantId;
      updateSubmitState();
    });
  });

  dateInput.addEventListener('change', updateSubmitState);
  timeSelect.addEventListener('change', updateSubmitState);

  submitButton.addEventListener('click', function () {
    if (!selectedVariantId || !dateInput.value || !timeSelect.value) return;

    submitButton.disabled = true;
    submitButton.textContent = 'Booking...';

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: selectedVariantId,
                quantity: 1,
                properties: {
                  'Appointment Date': dateInput.value,
                  'Appointment Time': timeSelect.value
                }
              }
            ]
          })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add appointment to cart');
        window.location.href = '/checkout';
      })
      .catch(function () {
        submitButton.disabled = false;
        submitButton.textContent = originalLabel;
        window.alert('Something went wrong booking your appointment. Please try again.');
      });
  });
})();
